import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { GlobalVariable } from "app/global/global";
import {
  SharePrescriptionRequest,
  SharePrescriptionResponse,
  Receta,
  CrearRecetaRequest,
  PaginatedRecetas,
} from "app/models/receta.interface";

export interface CanalesCompartir {
  whatsapp?: boolean;
  email?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class RecetaService {
  private readonly url = `${GlobalVariable.BASE_API_URL}api/recetario/recetas/`;
  private readonly recetasUrl = `${GlobalVariable.BASE_API_URL}api/recetas/`;
  private canalesCache: CanalesCompartir | null = null;

  constructor(private http: HttpClient) {}

  getCanalesCompartir(): Observable<CanalesCompartir> {
    if (this.canalesCache) {
      return of(this.canalesCache);
    }
    return this.http
      .get<CanalesCompartir>(
        `${GlobalVariable.BASE_API_URL}api/config-notificaciones/canales-compartir`,
      )
      .pipe(tap((canales) => (this.canalesCache = canales)));
  }

  sharePrescriptions(
    data: SharePrescriptionRequest,
  ): Observable<SharePrescriptionResponse> {
    return this.http.post<SharePrescriptionResponse>(
      `${this.url}compartir`,
      data,
    );
  }

  crear(data: CrearRecetaRequest): Observable<Receta[]> {
    return this.http.post<Receta[]>(`${this.recetasUrl}crear`, data);
  }

  listar(
    filtros?: Record<string, string | number>,
    page?: number,
    perPage?: number,
  ): Observable<PaginatedRecetas> {
    let params = new HttpParams();
    if (page != null) {
      params = params.set("page", page.toString());
    }
    if (perPage != null) {
      params = params.set("per_page", perPage.toString());
    }
    if (filtros) {
      for (const [key, value] of Object.entries(filtros)) {
        if (value != null) {
          params = params.set(key, value.toString());
        }
      }
    }
    return this.http.get<PaginatedRecetas>(`${this.recetasUrl}listar`, {
      params,
    });
  }

  mostrar(id: number): Observable<Receta> {
    return this.http.get<Receta>(`${this.recetasUrl}mostrar/${id}`);
  }

  anular(id: number): Observable<any> {
    return this.http.post(`${this.recetasUrl}${id}/anular`, {});
  }

  porPaciente(pacienteId: number): Observable<Receta[]> {
    return this.http.get<Receta[]>(`${this.recetasUrl}paciente/${pacienteId}`);
  }

  porMedico(medicoId: number): Observable<Receta[]> {
    return this.http.get<Receta[]>(`${this.recetasUrl}medico/${medicoId}`);
  }
}
